import React, { useEffect, useState } from "react";
import DynamicComponentRenderer from "../../components/DynamicComponentRenderer";
import Heading from "../../components/Heading";
import CommonGrid from "../../components/CommonGrid";
import { gridColumns_RolesMenu } from "../../Utils/TableColumnDefs";
import axios from "../../axios";
import urls from "../../Utils/urls";
import { useNavigate } from "react-router-dom";
import { SpinnerBlock } from "../../Utils/CustomComponent";
import { Button } from "../../components/Button";
import { useAbortController } from "../../hooks/useAbortController";
import { useSelector } from "react-redux";
import { oracleConfig } from "../../Utils/constant";

const RoleMenu = () => {
  const [rolesTableData, setRolesTableData] = useState([]);
  const [loading, setLoading] = useState("loading");
  const navigate = useNavigate();
  const selectedRoleValue = useSelector(
    (state) => state.account.selectedRole.value
  );
  const userId = `${localStorage.getItem("apex_userid")}`;
  const { signal } = useAbortController();
  useEffect(() => {
    // setRolesTableData([]);
    const fetchData = async () => {
      const res = await axios.get(
        urls.dashboard.getRole(userId, selectedRoleValue),
        oracleConfig,
        {
          signal,
        }
      );
      let data = res.data.items;
      // const newdata = data.filter((item) => item.role_level !== 3) || [];
      setRolesTableData(data);
      setLoading("fulfilled");
    };
    fetchData();
  }, [userId]);
  const componentConfig = [
    {
      component: <Heading className="col-sm-12" text="Role" />,
      role: ["Both"],
      className: "col-sm-6 px-4",
    },
    {
      component: (
        <Button
          className="add-role-button"
          onClick={() => navigate("/role-menu/Create")}
          text="Add Role"
        />
      ),
      role: ["Both"],
      className: "col-sm-6 px-4 text-end",
    },
    {
      component: (
        <CommonGrid
          className={"bg-white col-sm-12 mt-5 available-role-table"}
          title={"Available Roles"}
          gridColumns={gridColumns_RolesMenu}
          columnData={rolesTableData}
          status={loading}
        />
      ),
      role: ["Both"],
      className: "col-sm-12 px-4",
    },
  ];
  return (
    <div
      className="text-start container-fluid my-0 px-0"
      style={{ overflowY: "scroll" }}
    >
      <section
        className=" rounded py-5"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <article className="container-fluid row">
          <DynamicComponentRenderer componentConfig={componentConfig} />
        </article>
      </section>
    </div>
  );
};

export default RoleMenu;
